/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_area_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One hectare is about 2.471 acres. A hectare is a clean 10,000 square meters, while an acre comes from an old British definition (43,560 square feet, or about 4,046.86 square meters), so the ratio between them isn't a round number even though both are common on land listings.`)
};

const es_uc_area_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una hectárea es aproximadamente 2.471 acres. Una hectárea es un 10,000 metros cuadrados limpios, mientras que un acre viene de una definición británica antigua (43,560 pies cuadrados, o aproximadamente 4,046.86 metros cuadrados), así que la razón entre ellos no es un número redondo aunque ambos sean comunes en listados de tierra.`)
};

const de_uc_area_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Hektar sind etwa 2.471 Acres. Ein Hektar sind glatte 10,000 Quadratmeter, während ein Acre aus einer alten britischen Definition stammt (43,560 Quadratfuß bzw. etwa 4,046.86 Quadratmeter), sodass das Verhältnis zwischen beiden keine runde Zahl ist, auch wenn beide auf Grundstücksangeboten gebräuchlich sind.`)
};

const nl_uc_area_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eén hectare is ongeveer 2.471 acres. Een hectare is een nette 10.000 vierkante meter, terwijl een acre van een oude Britse definitie komt (43.560 vierkante voet, of ongeveer 4.046,86 vierkante meter), dus de verhouding daartussen is geen rond getal ook al zijn beide veelvoorkomen op landiniteven.`)
};

const fr_uc_area_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un hectare est environ 2,471 acres. Un hectare est un nombre net de 10 000 mètres carrés, tandis qu'un acre provient d'une définition britannique ancienne (43 560 pieds carrés, ou environ 4 046,86 mètres carrés), donc le rapport entre eux n'est pas un nombre rond même si les deux sont courants sur les annonces foncières.`)
};

const it_uc_area_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un ettaro è circa 2,471 acri. Un ettaro è un pulito 10.000 metri quadrati, mentre un acro proviene da una vecchia definizione britannica (43.560 piedi quadrati, o circa 4.046,86 metri quadrati), quindi il rapporto tra loro non è un numero rotondo anche se entrambi sono comuni negli elenchi di terreni.`)
};

const pt_br2_uc_area_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um hectare é cerca de 2.471 acres. Um hectare é 10.000 metros quadrados limpos, enquanto um acre vem de uma definição britânica antiga (43.560 pés quadrados, ou cerca de 4.046,86 metros quadrados), então a proporção entre eles não é um número redondo mesmo que ambos sejam comuns em listagens de terra.`)
};

const pt_uc_area_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um hectare é cerca de 2,471 acres. Um hectare é um 10000 metros quadrados limpo, enquanto um acre vem de uma definição britânica antiga (43560 pés quadrados, ou cerca de 4046,86 metros quadrados), portanto a razão entre eles não é um número redondo mesmo que ambos sejam comuns em listas de terras.`)
};

const ja_uc_area_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1ヘクタールは約2.471エーカーです。ヘクタールはきれいな10,000平方メートルであり、エーカーは古いイギリスの定義(43,560平方フィート、または約4,046.86平方メートル)からのため、それらの比率は、どちらかが土地リストで一般的であっても、丸い数ではありません。`)
};

const zh_uc_area_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation B]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_area_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_area_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_area_faq2_a", locale)
	if (locale === "en") return en_uc_area_faq2_a(inputs)
	if (locale === "es") return es_uc_area_faq2_a(inputs)
	if (locale === "de") return de_uc_area_faq2_a(inputs)
	if (locale === "nl") return nl_uc_area_faq2_a(inputs)
	if (locale === "fr") return fr_uc_area_faq2_a(inputs)
	if (locale === "it") return it_uc_area_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_uc_area_faq2_a(inputs)
	if (locale === "pt") return pt_uc_area_faq2_a(inputs)
	if (locale === "ja") return ja_uc_area_faq2_a(inputs)
	return zh_uc_area_faq2_a(inputs)
};